<!-- start of Table box -->
<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
	>
		<div class="o-stack__cell">
			<h5>{{ sectiontitle }}</h5>
			<span *ngIf="downloadConfiguration.enableDownload && hasData" class="datatable-icon">
				<a
					href="javascript:void(0)"
					class="datatable_download_icon"
					(click)="downloadDataInCSV($event)"
					target="_blank"
				>
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</span>
		</div>
	</div>

	<div class="c-portlet__content" *ngIf="hasData">
		<app-accordion-group>
			<app-accordion
				*ngFor="let creative of creatives; let i = index"
				[title]="creative.creativeName"
				[index]="i + 1"
				[active]="i === 0"
				[className]="creative.htmlClass"
			>
				<div *ngIf="!creative.isVideoCreative && !creative.isAudioCreative; else audioVideoCreativeBlock">
					<app-marketron-display-creative [creative]="creative"></app-marketron-display-creative>
				</div>
				<ng-template #audioVideoCreativeBlock>
					<app-marketron-preroll-creative
						*ngIf="!isRadio && creative.isVideoCreative"
						[creative]="creative"
					></app-marketron-preroll-creative>
					<app-marketron-audio-creative
						*ngIf="isRadio && creative.isAudioCreative"
						[creative]="creative"
					></app-marketron-audio-creative>
				</ng-template>
				<div class="clear"></div>
			</app-accordion>
			<div class="clear"></div>
		</app-accordion-group>
	</div>
	<div *ngIf="!hasData">
		<div class="map-no-data">No Data to Display</div>
	</div>
</div>
<!--End of Table box -->
